import { apiRequest, getApiBaseUrl, getStoredToken } from './apiClient';
import { getCsrfToken } from './authService';

const BASE = '/api/admin/training-videos';

export const fetchTrainingVideos = async (query = {}) => {
  const params = new URLSearchParams();
  if (query.kategoriId) params.set('kategoriId', query.kategoriId);
  if (query.durum) params.set('durum', query.durum);
  if (query.ara) params.set('ara', query.ara);
  const q = params.toString();
  return apiRequest(`${BASE}${q ? `?${q}` : ''}`, { method: 'GET' });
};

export const fetchTrainingVideoStatus = async (id) => {
  return apiRequest(`${BASE}/${encodeURIComponent(id)}/status`, { method: 'GET' });
};

export const fetchTrainingPlayback = async (id) => {
  return apiRequest(`${BASE}/${encodeURIComponent(id)}/playback`, { method: 'GET' });
};

export const patchTrainingVideo = async (id, body) => {
  return apiRequest(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body,
  });
};

export const deleteTrainingVideo = async (id) => {
  return apiRequest(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE' });
};

/**
 * Multipart upload with progress (büyük video için fetch timeout yok)
 * @param {FormData} formData — video, baslik, icerik, kategoriId, etiket id alanları
 * @param {(pct: number) => void} onProgress
 */
export const uploadTrainingVideoXhr = (formData, onProgress) => {
  const url = `${getApiBaseUrl()}${BASE}`;
  const token = getStoredToken();

  return getCsrfToken()
    .catch(() => null)
    .then(
      (csrf) =>
        new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('POST', url);
          if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
          if (csrf) xhr.setRequestHeader('X-CSRF-Token', csrf);
          xhr.withCredentials = true;
          xhr.upload.onprogress = (e) => {
            if (e.lengthComputable && typeof onProgress === 'function') {
              onProgress(Math.min(100, Math.round((e.loaded / e.total) * 100)));
            }
          };
          xhr.onload = () => {
            let data;
            try {
              data = JSON.parse(xhr.responseText || '{}');
            } catch {
              data = { mesaj: xhr.responseText || 'Yanıt okunamadı' };
            }
            if (xhr.status >= 200 && xhr.status < 300) resolve(data);
            else reject(new Error(data.mesaj || `HTTP ${xhr.status}`));
          };
          xhr.onerror = () => reject(new Error('Ağ hatası'));
          xhr.send(formData);
        })
    );
};
